import Custom from '@/api/custom'
let apiMark = new Custom('bookMarks')
const state = {
    marks: []
}

const actions = {
    async getMarks ({ commit }) {
        let res = await apiMark.getRecords({
            pageIndex: 1,
            pageSize: 999
        })
        let marks = res.rows
        commit('setMarks', marks)
        return res
    }
}
const mutations = {
    setMarks (state, val) {
        state.marks = val
    }
}

export default {
    state,
    actions,
    mutations
}
